import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import 'babel-polyfill'
import App from './App'
import router from './router'
import store from './store'
import {i18n} from './plugins/i18n'
import FlagIcon from 'vue-flag-icon'
import VueTelInput from 'vue-tel-input'
import UUID from 'vue-uuid'
import browserDetect from "vue-browser-detect-plugin"
import Push from 'push.js'
import * as firebase from "firebase/app"
import "firebase/messaging"
import VueExcelXlsx from "vue-excel-xlsx"
import QRCode from 'qrcode'
import jsPDF from 'jspdf'

// Hacer librerías disponibles globalmente
window.QRCode = QRCode
window.jsPDF = jsPDF

if (firebase.messaging.isSupported()) {
    console.log('Push Notifications Supported')
    const messaging = firebase.messaging();

    messaging.usePublicVapidKey("BLRxFmjzsUv9Or1sLiwA_KND6Kp5IWHJzGD-huvytLv_IBm05b-PemHjDiHA-EwO1Q7UQliXNIMyn6q6SqlOhpQ");

    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.')
            // TODO(developer): Retrieve an Instance ID token for use with FCM.
            // ...
        } else {
            console.log('Unable to get permission to notify.')
        }
    })

    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.setBackgroundMessageHandler` handler.
    messaging.onMessage((payload) => {
        console.log('Message received focus app. ', payload.notification);
        Push.create(payload.notification.title, {
            body: payload.notification.body,
            icon: require('./assets/intLogo.png'),
            onClick: function () {
                window.focus();
                this.close();
            }
        })
    })
} else {
    console.log('Push Notifications Not Supported')
}

Vue.config.productionTip = false;
Vue.use(FlagIcon)
Vue.use(VueTelInput)
Vue.use(UUID)
Vue.use(browserDetect)
Vue.use(VueExcelXlsx)
const axios = require('axios');

new Vue({
    router,
    store,
    axios,
    i18n,
    render: h => h(App)
}).$mount('#app');
